import { render } from "./RolesList.vue?vue&type=template&id=224d8da2&ts=true"
import script from "./RolesList.vue?vue&type=script&lang=ts"
export * from "./RolesList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Roles/RolesList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "224d8da2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('224d8da2', __exports__)) {
    api.reload('224d8da2', __exports__)
  }
  
  module.hot.accept("./RolesList.vue?vue&type=template&id=224d8da2&ts=true", () => {
    api.rerender('224d8da2', render)
  })

}


export default __exports__